// extracted by css-extract-rspack-plugin
export default {"loader":"_30hPW51WEmRAKyDe_jp_lH"};